import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {Link} from 'react-router-dom';
import {Popup} from '../common';

import {
  pinProcess,
  pinStage,
  pinProperty,
  pinboardOverlay,
  clearPinboard,
  refreshSearchProcessDetail,
  exportExcel,
  exportPDF,
} from '../../redux/actions';

class OverlayPinboard extends Component {
  onView(processId) {
    this.props.pinboardOverlay(false);
    this.props.refreshSearchProcessDetail(true, processId);
  }

  renderProcesses() {
    // console.log(this.props, 'HIHI');
    const processes = this.props.pinboard.process;

    // console.log('renderProcesses', processes);

    return processes.map((process, index) => {
      // console.log('processes.map', process);

      return (
        <div
          key={index}
          className="process hlp-flex flex-aic flex-jcsb hlp-pd-20 full-border">
          <div className="process-data">
            <div className="process-title">{process.name}</div>
          </div>

          <div>
            <Link
              className="btn accent-invert no-border"
              onClick={() => this.onView(process.id)}
              to={`/process/${process.id}`}>
              View
            </Link>
            <button
              className="btn accent-invert no-border"
              onClick={() => this.props.pinProcess(process.id, 'X')}>
              Unpin
            </button>
          </div>
        </div>
      );
    });
  }

  renderStages() {
    const stages = this.props.pinboard.stage;

    return stages.map((stage, index) => {
      return (
        <div
          key={index}
          className="process stage hlp-flex flex-aic flex-jcsb hlp-pd-20 full-border">
          <div className="process-data">
            <div className="process-title">{stage.process_name}</div>
            <div className="stage">-- {stage.name}</div>
          </div>

          <div>
            <Link
              className="btn accent-invert no-border"
              onClick={() => this.onView(stage.process_id)}
              to={`/process/${stage.process_id}/stage/${stage.id}`}>
              View
            </Link>
            <button
              className="btn accent-invert no-border"
              onClick={() =>
                this.props.pinStage(stage.id, 'X', stage.process_id, 'X')
              }>
              Unpin
            </button>
          </div>
        </div>
      );
    });
  }

  exportAllExcel() {
    // console.log('exportAllExcel', this.props.pinboard);
    this.props.exportExcel(this.props.pinboard, '');
  }

  renderProperties() {
    const properties = this.props.pinboard.property;

    return properties.map((property, index) => {
      return (
        <div
          key={index}
          className="process stage hlp-flex flex-aic flex-jcsb hlp-pd-20 full-border">
          <div className="process-data">
            <div className="process-title">{property.process_name}</div>
            <div className="stage">-- {property.stage_name}</div>
            <div className="property">---- {property.name}</div>
          </div>

          <div>
            <Link
              className="btn accent-invert no-border"
              onClick={() => this.onView(property.process_id)}
              to={`/process/${property.process_id}/stage/${property.stage_id}/property/${property.id}`}>
              View
            </Link>
            <button
              className="btn accent-invert no-border"
              onClick={() =>
                this.props.pinProperty(
                  property.id,
                  '',
                  property.process_id,
                  'X',
                  property.stage_id,
                  'X',
                )
              }>
              Unpin
            </button>
          </div>
        </div>
      );
    });
  }

  render() {
    return (
      <div className="overlay-wrapper">
        <div className="overlay-box">
          <div className="title">Pinboard</div>
          <div className="body">
            <div className="overlay-pinboard">
              {this.renderProcesses()}
              {this.renderStages()}
              {this.renderProperties()}

              {this.props.pinboard.process.length <= 0 &&
                this.props.pinboard.stage.length <= 0 &&
                this.props.pinboard.property.length <= 0 && (
                  <div className="pinboard-empty">Your pinboard is empty.</div>
                )}
            </div>
          </div>

          <div className="actions hlp-flex flex-aic flex-jcsb">
            <button
              className="btn invert no-border"
              onClick={() => this.props.clearPinboard()}>
              Remove all pins
            </button>
            <div className="flex-grow-me hlp-flex flex-aic flex-jcfe">
              <Popup
                className="helptip-text"
                trigger={() => <span className="helptip"></span>}
                position="top center"
                on={['hover']}
                closeOnDocumentClick>
                <span>
                  All the information you have pinned into this Pinboard you can export either as a PDF or in Excel. You can also remove all or some of the ‘pinned’ information if you realize it is no longer necessary.
                </span>
              </Popup>
            </div>
            <div>
              <button
                className="btn accent-invert"
                onClick={() => this.exportAllExcel()}
                // disabled={this.props.pinboard.process.length < 1}
                title="You can only export pinned processes to excel">
                Export all to Excel
              </button>
              <button
                className="btn primary"
                onClick={() =>
                  this.props.exportPDF({pinboard: this.props.pinboard})
                }
                disabled={
                  this.props.pinboard.process.length < 1 &&
                  this.props.pinboard.stage.length < 1 &&
                  this.props.pinboard.property.length < 1
                }>
                Export to PDF
              </button>
            </div>
          </div>

          <div
            className="overlay-close"
            onClick={() => this.props.dismissOverlay()}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {pinboard: state.pinboard.pinboard};
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      pinProcess,
      pinStage,
      pinProperty,
      pinboardOverlay,
      clearPinboard,
      refreshSearchProcessDetail,
      exportExcel,
      exportPDF,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(OverlayPinboard);
